<template>
    <better-link class="link" :to="permalink">
        <div class="search-result d-flex flex-column flex-md-row align-items-stretch">
            <div class="mr-md-3 mb-2 mb-md-0">
                <div class="featured-image small-corners" :style="`background-image:url(${site.photos.length ? site.photos[0].permalink + '?w=800' : '//drench.imgix.net/media/drench-site-no-image.jpg?w=800'});`">
                    <div v-if='nudityAvailable(site)' class="featured-attribute shadow">{{ nudityAvailable(site) | ucWords }}</div>
                </div>
            </div>
            
            <div class="search-result-content d-flex flex-column justify-content-between w-100">
                <div class="d-flex justify-content-between">
                    <div>
                        <h4>{{ site.name }}</h4>
                        <address class="mb-1">{{ site.location.formatted_locality }}</address>
                    </div>
                    <HeartCircleButton :site="site" @data-changed="$listeners['data-changed']" variant="dark" class="ml-auto" />
                </div>
                <div class="text-muted">{{ site.short_description }}</div>
                <ul class="important-attributes list-unstyled d-flex justify-content-left mt-1 mb-0">
                    <li v-if="site.min_price > 0">{{ formattedLowestPrice(site) }}</li>
                    <li v-if="site.number_of_pools > 0">{{ site.number_of_pools | withDeclensionalWord(' pool', ' pools') }}</li>
                    <li v-if="site.min_temp > 0">{{ temperatureRange(site) }}</li>
                </ul>
                <div class="d-flex justify-content-between">
                    <StarRating v-if="site.average_ratings && Object.keys(site.average_ratings).length" :rating="combinedAverageRating(site.average_ratings)" class="star-rating" />
                    <div v-else>&nbsp;</div>
                    <li v-if="site.hours && Object.keys(site.hours).length" class="open-info">{{ openInfo }}</li>
                </div>
            </div>
        </div>
    </better-link>
</template>

<script>
import HeartCircleButton from '../elements/HeartCircleButton'
import StarRating from '../elements/StarRating'
import SiteMixins from '@/mixins/SiteMixins';
import CurrencyMixins from '@/mixins/CurrencyMixins';

export default {
    name: 'SearchResult',
    mixins: [
        SiteMixins,
        CurrencyMixins,
    ],
    components: {
        HeartCircleButton,
        StarRating,
    },
    props: {
        site: {
          type: Object,
          required: true,
        },
        isSaveLoading: {
          type: Boolean,
          required: false,
          default: false,
        },
    },
    computed: {
        openInfo() {
            if (this.isOpenNow(this.site.hours, this.site.location.timezone)) {
                return 'Open Now'
            }
            return 'Closed Now'
        },
        permalink() {
            return '/sites/'+this.site.slug
        },
    },
    methods: {
    },
};
</script>

<style lang="scss">
.link {
    &:hover {
        text-decoration: none;
    }
    
    .search-result {
        margin: 10px 0;
        padding: 8px;
        background: $off-white;
        
        .featured-image {
            position: relative;
            width: 250px;
            height: 0;
            padding-top: 160px;
            background-position: center center;
            background-size: cover;
            
            @include media-breakpoint-down(sm) {
                width: 100%
            }
            
            .featured-attribute {
                position: absolute;
                bottom: 15px;
                left: 15px;
                padding: 4px 8px;
                background: white;
                border: $light-gray;
                border-radius: 4px;
                text-transform: uppercase;
                font-size: 11px;
                font-weight: bold;
                color: $almost-black;
            }
        }
        
        .search-result-content {
            h4 {
                margin: 0;
                font-size: 18px;
            }
            address {
                color: $dark-gray;
                margin-bottom: 0;
                font-size: 15px;
            }
            .text-muted {
                font-size: 14px;
            }
            .important-attributes {
                font-size: 12px;
                color: $dark-gray;
                margin: 0;
                
                li {
                    margin-right: 20px;
                }
            }
            .star-rating {
                color: $darkest-gray;
            }
            .open-info {
                font-size: 12px;
                color: $darkest-gray;
            }
        }
    }
}
</style>


